module.exports = "<main>\n\t<div class=\"connection-success\">\n\t\t<span>Авторизация прошла успешно</span>\n\t</div>\t\n\n\t<article>\n\t\t<div class=\"phone-call\">\n\t\t\t<p>6 часов сёрфинга:</p>\n\t\t\t<small>\"Интернет будет работать ровно 6 часов. После этого для продолжения пользования нужно переподключиться к сети Wi-Fi. Проходить заново авторизацию и звонить нам не потребуется!\"</small>\n\t\t</div>\n\t\t<div class=\"buttons\">\n\t\t\t<button class=\"center\" \n\t\t\t[style.background]=\"'#' + clientInfo.service['color.rgb']\" (click)=\"openNewTab()\">Войти в интернет</button></div>\n\t</article>\n</main>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/success/success.template.html
 ** module id = 994
 ** module chunks = 1
 **/